/** `entity_type` of the project-wide timeline (`GET /timeline`) */
export enum TIMELINE_ENTITY_TYPE {
  CARD = 'card',
  CONTACT = 'contact',
  COMPANY = 'company_v2',
  TASK = 'task',
  CHAT = 'chat',
}

export enum TIMELINE_ACTOR_TYPE {
  USER = 'USER',
  SYSTEM = 'SYSTEM',
}

/** For a system event every field is null */
export interface TimelineUser {
  id: string | null;
  first_name: string | null;
  last_name: string | null;
  avatar_url: string | null;
  email?: string | null;
  status?: string | null;
}

/** What the event is about (only `GET /timeline` has it); `funnel_type` only for a card, the names for a contact */
export interface TimelineEntityInfo {
  name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  funnel_type?: string | null;
  /** False when the entity is deleted */
  active?: boolean | null;
}

export interface TimelineEvent<XData = Record<string, any>> {
  id: string;
  created_at: string;
  entity_type?: string;
  entity_id?: string;
  event_type: string;
  action: string;
  sub_type: string | null;
  x_data: XData;
  created_by: string | null;
  created_by_type: TIMELINE_ACTOR_TYPE | null;
  created_by_user: TimelineUser | null;
  entity?: TimelineEntityInfo | null;
}

/** Every filter is optional; `date_from` and `date_to` are inclusive, `page` starts from 1, `take` is up to 200 */
export interface TimelineEventsQuery {
  entity_type?: TIMELINE_ENTITY_TYPE;
  entity_id?: string;
  created_by?: string;
  created_by_type?: TIMELINE_ACTOR_TYPE;
  /** Any of these types */
  event_type?: string[];
  action?: string;
  sub_type?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  take?: number;
}

/** Newest first */
export interface TimelineEventsPage {
  items: TimelineEvent[];
  total: number;
  size: number;
  page: number;
}

/** `chat:timeline:new`, sent to everyone who can open the chat, the author included */
export interface ChatTimelineSocket {
  chat_id: string;
  events: TimelineEvent[];
}
